import { render, staticRenderFns } from "./PublicationTableAction.vue?vue&type=template&id=b2ae5afc"
import script from "./PublicationTableAction.vue?vue&type=script&lang=js"
export * from "./PublicationTableAction.vue?vue&type=script&lang=js"
import style0 from "./PublicationTableAction.vue?vue&type=style&index=0&id=b2ae5afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports